import { getActionTypeFromInstance } from '@ngxs/store';
import {
    reduce as _reduce,
    includes as _includes
} from 'lodash';
import { allStateSliceDefaults } from '@oneapp/main/core/store';
import { Logout } from '../auth/auth.actions';
import { ResetState } from '../state.actions';

const clearStateOnActionsTypes = [
    Logout.type,
    ResetState.type
];

/**
 * Clears the state and resets it to its default values when certain actions are dispatched
 * @param state
 * @param action
 * @param next
 * @returns
 */
export function clearStatePlugin(state, action, next) {
    const actionType = getActionTypeFromInstance(action);
    if (_includes(clearStateOnActionsTypes, actionType)) {
        const defaultStateObject = _reduce(allStateSliceDefaults, (result, stateDefault) => {
            result[stateDefault.sliceName] = stateDefault.defaults;
            return result;
        }, {});
        state = defaultStateObject;
    }
    return next(state, action);
}
